import { Reveal } from "@/components/lunar/Reveal";

const EVENT_TYPES = [
    {
        title: "Networking",
        copy: "Turn a room full of people into useful introductions.",
        src: "/assets/events/events-after-work.webp",
        alt: "Illustrative Lunar branding at an after-work networking event",
    },
    {
        title: "Festivals & social events",
        copy: "Help groups discover the people around them.",
        src: "/assets/events/events-festival-social.webp",
        alt: "Illustrative Lunar branding at an outdoor festival social event",
    },
    {
        title: "Universities & freshers",
        copy: "Make meeting new people easier from day one.",
        src: "/assets/events/events-university-freshers.webp",
        alt: "Illustrative Lunar branding at a university freshers event",
    },
    {
        title: "Conferences & exhibitions",
        copy: "Help delegates find the people worth meeting.",
        src: "/assets/events/events-conference-exhibition.webp",
        alt: "Illustrative Lunar branding at a conference or exhibition",
    },
];

export const EventTypes = () => (
    <section data-testid="events-types-section" className="mx-auto max-w-6xl px-6 pb-16 pt-6 sm:pb-20 sm:pt-8">
        <h2 className="sr-only">Event types</h2>
        <Reveal>
            <div data-testid="events-types-grid" className="grid gap-8 md:grid-cols-2 lg:gap-10">
                {EVENT_TYPES.map((event, i) => (
                    <figure key={event.title} data-testid={`event-type-card-${i + 1}`}>
                        <div className="overflow-hidden rounded-3xl border border-[#E5E3DC] bg-[#F0EFEB]">
                            <img
                                src={event.src}
                                alt={event.alt}
                                data-testid={`event-type-image-${i + 1}`}
                                loading="lazy"
                                className="aspect-[4/3] w-full object-cover"
                            />
                        </div>
                        <figcaption className="mt-5">
                            <h3
                                data-testid={`event-type-title-${i + 1}`}
                                className="font-display text-2xl font-semibold tracking-tight text-[#1D201A]"
                            >
                                {event.title}
                            </h3>
                            <p
                                data-testid={`event-type-copy-${i + 1}`}
                                className="mt-2 text-base leading-relaxed text-[#5C5F58]"
                            >
                                {event.copy}
                            </p>
                        </figcaption>
                    </figure>
                ))}
            </div>
            <p
                data-testid="events-grid-illustrative-text"
                className="mt-8 text-center text-xs tracking-wide text-[#5C5F58] opacity-75"
            >
                Illustrative event imagery.
            </p>
        </Reveal>
    </section>
);
